import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse } from 'utils';

export const CATEGORY_ATHLETES_REQUEST = 'CATEGORY_ATHLETES_REQUEST';
export const CATEGORY_ATHLETES_SUCCESS = 'CATEGORY_ATHLETES_SUCCESS';
export const CATEGORY_ATHLETES_FAILURE = 'CATEGORY_ATHLETES_FAILURE';

/**
 * Lazily fetches athlete list for a single category slot.
 * Should be dispatched on hover; callers should skip if already in cache.
 *
 * @param {string} competitionId
 * @param {string} slotKey  – base slot key (no "#N" suffix needed, stripped server-side)
 */
export const fetchCategoryAthletes = (competitionId, slotKey) => {
  return function (dispatch) {
    dispatch({ type: CATEGORY_ATHLETES_REQUEST, slotKey });

    return axios(
      apiRequestOptions(apiPath.SCHEDULE.CATEGORY_ATHLETES, null, {
        // encodeURIComponent so that '#' in split keys (e.g. "uuid#2") is safe in the URL path.
        params: { id: competitionId, slotKey: encodeURIComponent(slotKey) },
      })
    )
      .then(transformHttpResponse)
      .then(response =>
        dispatch({
          type: CATEGORY_ATHLETES_SUCCESS,
          slotKey,
          athletes: response.data.athletes,
        })
      )
      .catch(error => transformHttpResponse(error.response))
      .catch(() => {
        dispatch({ type: CATEGORY_ATHLETES_FAILURE, slotKey });
      });
  };
};
